export const blurVariables = {
  'blur-xs': '8px',
  'blur-sm': '16px',
  'blur-md': '24px',
  'blur-lg': '40px',
  'blur-xl': '72px',
  'blur-xxl': '128px',
};
